import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useVideoFeedback } from './useVideoFeedback';
import { IconInfo } from '../../../../utils/icons';
import { openFeedbackCriteria } from './FeedbackCriteriaDialog';

export const FeedbackCriteria: FC = () => {
  const { showFeedbackCriteria } = useVideoFeedback();

  if (!showFeedbackCriteria) return null;

  return (
    <Box className="flex gap-2 items-center cursor-pointer" onClick={openFeedbackCriteria}>
      <Box className="flex items-center justify-center">
        <IconInfo size={22} />
      </Box>
      <Typography variant="body1" className="text-text-2">
        Please review our Feedback Criteria
      </Typography>
    </Box>
  );
};

export default FeedbackCriteria;
